import { GraduationCap, Sparkles, BookOpen, MessageCircle } from "lucide-react";
import AppHeader from "@/components/layout/AppHeader";
import { FaqList } from "@/components/copiloto/FaqList";

export default function CapacitacionPage() {
  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#EDF5F3] text-[#1F4640] text-xs font-bold uppercase tracking-widest">
            <Sparkles className="w-3.5 h-3.5" /> Próximamente
          </div>
          <div className="mt-8 mx-auto w-20 h-20 rounded-3xl bg-[#1E3A5F] text-white flex items-center justify-center shadow-xl shadow-[#1E3A5F]/20">
            <GraduationCap className="w-10 h-10" strokeWidth={2.2} />
          </div>
          <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]" data-testid="capacitacion-title">
            Capacitación 360
          </h1>
          <p className="mt-4 text-slate-600 text-base sm:text-lg max-w-xl mx-auto leading-relaxed" data-testid="capacitacion-description">
            Un centro de aprendizaje pensado para asesores inmobiliarios en México: cápsulas cortas, casos reales
            y explicaciones jurídicas que te acompañarán mientras trabajas con tus clientes.
          </p>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
            <div className="p-5 rounded-2xl bg-white border border-[#E2DCD2]">
              <BookOpen className="w-5 h-5 text-[#2A5C55]" />
              <h3 className="mt-2 font-heading font-bold text-slate-900">Cápsulas por documento</h3>
              <p className="mt-1 text-xs text-slate-600">Aprende qué firmar, cuándo y por qué antes de cada operación.</p>
            </div>
            <div className="p-5 rounded-2xl bg-white border border-[#E2DCD2]">
              <MessageCircle className="w-5 h-5 text-[#1E3A5F]" />
              <h3 className="mt-2 font-heading font-bold text-slate-900">Preguntas frecuentes</h3>
              <p className="mt-1 text-xs text-slate-600">Respuestas de revisión jurídica y fiscal para casos comunes.</p>
            </div>
            <div className="p-5 rounded-2xl bg-white border border-[#E2DCD2]">
              <Sparkles className="w-5 h-5 text-[#B8873D]" />
              <h3 className="mt-2 font-heading font-bold text-slate-900">Certificaciones</h3>
              <p className="mt-1 text-xs text-slate-600">Insignias que te distinguen frente a propietarios y clientes.</p>
            </div>
          </div>

          <p className="mt-10 text-xs text-slate-400">
            En construcción. Te avisaremos por WhatsApp cuando esté disponible.
          </p>
        </div>
        <section className="mt-14" data-testid="faq-section">
          <h2 className="font-heading text-2xl font-extrabold text-slate-900 mb-4">Preguntas frecuentes</h2>
          <FaqList />
        </section>
      </main>
    </div>
  );
}
